module.exports = __webpack_public_path__ + "static/images/error-tools.d270963cb84c2f471c84e1990dffb7af.svg";